/**
 * Method that, depending on whether the user is logged in or not, returns one header or another.
 * Adds X-User-Role / X-User-Sst-Id when available so backend middleware can validate
 * role-based access (reportes, items por rol). See config/roles_sst.php.
 * Adds X-User-Name (URI-encoded) for the PDF version-control history.
 * @returns {string} the header for the request
 */
const authHeader = () => {
  let user = JSON.parse(localStorage.getItem('user'));
  let info = JSON.parse(localStorage.getItem('info'));
  let headers = {};
  if (user && user.token) {
    headers.Authorization = 'Bearer ' + user.token;
  }
  if (info && info.role !== null && info.role !== undefined) {
    headers['X-User-Role'] = String(info.role);
  }
  if (info && info.sstID !== null && info.sstID !== undefined) {
    headers['X-User-Sst-Id'] = String(info.sstID);
  }
  // Nombre para el control de versiones de los PDF (quién hizo el cambio).
  // Los headers HTTP deben ser ASCII, y los nombres traen tildes y ñ, así que
  // viaja codificado y el backend lo decodifica.
  const nombre = user && user.nodexum && user.nodexum.name;
  if (nombre) {
    headers['X-User-Name'] = encodeURIComponent(nombre);
  }
  return headers;
}

export default authHeader
